import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Modal } from '../../../../core/services/modal';
import { Button } from "../../../ui/button/button";
import { InputField } from "../../../ui/input-field/input-field";
import { OtpModal } from '../otp-modal/otp-modal';

@Component({
  selector: 'app-reference-id-modal',
  imports: [TranslatePipe, CommonModule, Button, InputField, ReactiveFormsModule],
  templateUrl: './reference-id-modal.html',
  styleUrl: './reference-id-modal.css'
})
export class ReferenceIdModal {
  @Input() options?: any;
  @Output() handleBtn = new EventEmitter<void>();

  referenceForm: FormGroup;
  otpVerified: boolean = false;
  mobile: string = '••••••8430';

  constructor(private modalService: Modal, private fb: FormBuilder,
    private router: Router
  ) {
    this.referenceForm = this.fb.group({
      referenceId: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(7)]]
    });
  }

  submitReferenceId() {
    // console.log(this.referenceForm.get);
    this.getOtpModal();
  }

  close(): void {
    this.modalService.close();
  }

  getOtpModal() {
    const otpModalOptions = {
      backdropClosable: false,
      showCancelButton: true,
      showConfirmButton: true,
      textConfirmButton: 'OTP_MODAL.VERIFY',
      headerIconPath: 'assets/icons/mobile-verify.svg',
      title: 'OTP_MODAL.TITLE_MOBILE',
      message: 'OTP_MODAL.MESSAGE_MOBILE',
      mobile: this.mobile,

      onSubmitOtp: (isOtpValid: boolean) => {
        this.otpVerified = isOtpValid;
        console.log('OTP validation result:', this.otpVerified);

        if (isOtpValid) {
          this.modalService.close();

          const referenceId = this.referenceForm.get('referenceId')?.value;

          if (referenceId) {
            //todo: after otp verifcaiton handle here next thing
            this.router.navigate(['/onboarding']);
          } else {
            console.error('Missing referenceId form');
          }
        } else {
          console.log('Invalid OTP');
        }
      },

      onResendCode: () => {
        console.log('Resend code triggered');
        // TODO: call API to resend OTP
      },
    };

    this.modalService.open(OtpModal, otpModalOptions);
  }

  get referenceIdControl(): FormControl {
    return this.referenceForm.get('referenceId') as FormControl;
  }

}
